// Chips : toggle sélection + suppression
document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-chip]');
    if (!chip) return;
    const rm = e.target.closest('.chip__remove');
    if (rm) { chip.remove(); return; }
    const isSelected = chip.getAttribute('data-selected') === 'true';
    chip.setAttribute('data-selected', String(!isSelected));
});
